import {
  LegislativnyMaterialListExternalApi,
  LegMaterialListItem,
  StadiumMaterialuEnum,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new LegislativnyMaterialListExternalApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchLegislativnyMaterialList = async (
  stadiumMaterialu: StadiumMaterialuEnum,
):
  Promise<ClientResponse<LegMaterialListItem[]>> => {
  const {
    data,
    status,
  } = await client.getLatestLegMaterialList(stadiumMaterialu);
  return {
    data,
    responseCode: status,
  };
};
